<one-card [notPadding]="true">

  <div class="fh-table-header">
    <span class="fh-table-title">Purchase orders</span>
    <one-input
      #searchInput
      class="fh-search"
      label="Search"
      type="search"
      autocomplete="off"
      (input)="onSearch($event)"
    ></one-input>
  </div>

  <div class="fh-divider"></div>

  <div class="fh-filters">
    <div class="fh-filters-left">
      <div class="fh-filter-item">
        <one-select
          #makerSelect
          class="one-select standard"
          [config]="selectConfig"
          [multiple]="true"
          [dataSource]="makerDataSource"
          label="Maker"
          size="small"
          (selectionChanged)="onMakerChange(makerSelect.control.value)"
        ></one-select>
      </div>
      <div class="fh-filter-item">
        <one-select
          #companySelect
          class="one-select standard"
          [config]="selectConfig"
          [multiple]="true"
          [dataSource]="companyDataSource"
          label="Company to bill"
          size="small"
          (selectionChanged)="onCompanyChange(companySelect.control.value)"
        ></one-select>
      </div>
      <div class="fh-filter-item">
        <one-select
          #sourceTypeSelect
          class="one-select standard"
          [config]="selectConfigNoSearch"
          [multiple]="true"
          [dataSource]="sourceTypeDataSource"
          label="Source type"
          size="small"
          (selectionChanged)="onSourceTypeChange(sourceTypeSelect.control.value)"
        ></one-select>
      </div>
      <div class="fh-filter-item">
        <one-select
          #statusSelect
          class="one-select standard"
          [config]="selectConfig"
          [multiple]="true"
          [dataSource]="statusDataSource"
          label="Status"
          size="small"
          (selectionChanged)="onStatusChange(statusSelect.control.value)"
        ></one-select>
      </div>
      <div class="fh-filter-item">
        <one-select
          #ownerSelect
          class="one-select standard"
          [config]="selectConfig"
          [multiple]="true"
          [dataSource]="ownerDataSource"
          label="Owner"
          size="small"
          (selectionChanged)="onOwnerChange(ownerSelect.control.value)"
        ></one-select>
      </div>
    </div>
    <div class="fh-filters-right" *ngIf="isAdmin">
      <label class="fh-po-test-checkbox">
        <input
          type="checkbox"
          class="rp-switch"
          [(ngModel)]="filterIsTest"
          (change)="onTestToggle()"
        >
        <span>PO test</span>
      </label>
    </div>
  </div>

  <one-dynamic-table *ngIf="tableData" [tableData]="tableData"></one-dynamic-table>

</one-card>

<ng-template #sourceTypeTemplate let-sourceType="sourceType" let-colorClass="colorClass">
  <span class="fh-source-badge" [ngClass]="colorClass">
    <span class="fh-source-dot"></span>{{ sourceType }}
  </span>
</ng-template>

<ng-template #statusTemplate let-label="label" let-code="code">
  <span class="fh-status-badge" [ngClass]="'fh-status--' + code">{{ label }}</span>
</ng-template>

<ng-template #actionsTemplate let-po="po" let-statusCode="statusCode">
  <div class="fh-row-actions">
    <button *ngIf="canViewDetail(po)" class="fh-row-actions__btn"
            (click)="viewOrder(po, statusCode)"
            [title]="statusCode === 'draft' ? 'Edit purchase order' : 'View purchase order'">
      <span class="one-icon-eye"></span>
    </button>
  </div>
</ng-template>
